import axios from 'axios';

export const BACKEND_URL = process.env.REACT_APP_BACKEND_URL || '';
export const API = `${BACKEND_URL}/api`;

export const TOKEN_KEY = 'spunkram_token';

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const t = localStorage.getItem(TOKEN_KEY);
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    const url = err?.config?.url || '';
    // Auth endpoints handle their own 401s (wrong password, invalid Google session, ...)
    const isAuthCall = url.includes('/auth/login') || url.includes('/auth/register') || url.includes('/auth/google');
    if (err?.response?.status === 401 && !isAuthCall) {
      localStorage.removeItem(TOKEN_KEY);
      if (!window.location.pathname.startsWith('/giris') && window.location.pathname !== '/') {
        window.location.href = '/giris';
      }
    }
    return Promise.reject(err);
  }
);

export const errMsg = (e, fallback = 'Bir şeyler ters gitti. Tekrar dene.') => {
  const d = e?.response?.data?.detail;
  if (typeof d === 'string') return d;
  if (Array.isArray(d) && d[0]?.msg) return d[0].msg;
  return e?.message === 'Network Error' ? 'Sunucuya ulaşılamadı. Bağlantını kontrol et.' : fallback;
};

export const fileUrl = (u) => (u ? `${BACKEND_URL}${u}` : null);

export default api;
